var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle2, _circle3, _path37, _circle4, _path38, _circle5, _circle6, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMesheryIntegrations = function SvgMesheryIntegrations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 369,
    height: 279,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCD918",
    fillRule: "evenodd",
    d: "M292.663 233h3.751c.358 0 .663.292.663.663v3.751a.664.664 0 0 1-.663.663h-3.751a.664.664 0 0 1-.663-.663v-3.751c.013-.358.305-.663.663-.663",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#04BDD9",
    fillRule: "evenodd",
    d: "M302.817 233h34.203c.358 0 .662.292.662.663v3.751a.664.664 0 0 1-.662.663h-34.203a.664.664 0 0 1-.662-.663v-3.751c0-.358.291-.663.662-.663",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCD918",
    fillRule: "evenodd",
    d: "M337.02 243.155h-3.752a.664.664 0 0 0-.663.662v3.752c0 .371.292.663.663.663h3.752a.665.665 0 0 0 .663-.663v-3.752a.664.664 0 0 0-.663-.662",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#04BDD9",
    fillRule: "evenodd",
    d: "M316.724 243.155h-24.061a.673.673 0 0 0-.663.662v3.752c0 .358.292.663.663.663h24.061a.665.665 0 0 0 .663-.663v-3.752a.656.656 0 0 0-.663-.662",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCD918",
    fillRule: "evenodd",
    d: "M326.878 243.155h-3.751a.664.664 0 0 0-.663.662v3.752c0 .371.292.663.663.663h3.751a.665.665 0 0 0 .663-.663v-3.752a.673.673 0 0 0-.663-.662",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#04BDD9",
    fillRule: "evenodd",
    d: "M326.878 253.296h-24.061a.664.664 0 0 0-.662.663v3.751c0 .358.291.663.662.663h24.061a.664.664 0 0 0 .663-.663v-3.751a.674.674 0 0 0-.663-.663",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCD918",
    fillRule: "evenodd",
    d: "M337.02 253.296h-3.752a.665.665 0 0 0-.663.663v3.751c0 .372.292.663.663.663h3.752a.664.664 0 0 0 .663-.663v-3.751a.665.665 0 0 0-.663-.663m-40.606 0h-3.751a.665.665 0 0 0-.663.663v3.751c0 .372.292.663.663.663h3.751a.664.664 0 0 0 .663-.663v-3.751a.656.656 0 0 0-.663-.663m-3.751 10.141h3.751c.358 0 .663.292.663.663v3.752a.664.664 0 0 1-.663.663h-3.751a.665.665 0 0 1-.663-.663V264.1c.013-.358.305-.663.663-.663",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#04BDD9",
    fillRule: "evenodd",
    d: "M312.959 263.437h24.061c.358 0 .662.292.662.663v3.752a.664.664 0 0 1-.662.663h-24.061a.665.665 0 0 1-.663-.663V264.1c0-.358.292-.663.663-.663",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCD918",
    fillRule: "evenodd",
    d: "M302.817 263.437h3.752c.358 0 .663.292.663.663v3.752a.665.665 0 0 1-.663.663h-3.752a.664.664 0 0 1-.662-.663V264.1c0-.358.291-.663.662-.663m34.203 10.168h-3.752a.665.665 0 0 0-.663.663v3.752c0 .371.292.662.663.662h3.752a.663.663 0 0 0 .662-.662v-3.752a.664.664 0 0 0-.662-.663",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#04BDD9",
    fillRule: "evenodd",
    d: "M326.878 273.605h-34.202a.665.665 0 0 0-.663.663v3.752c0 .358.292.663.663.663h34.202a.665.665 0 0 0 .663-.663v-3.752a.674.674 0 0 0-.663-.663",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "M193.106 107.085v32.519l28.197-16.315zM193.106 146.4v32.681l28.46-16.265z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M189.05 139.382v-32.025l-27.844 15.962zM133.189 178.96a68.4 68.4 0 0 0 21.6 21.729v-34.223zM189.05 178.919v-32.277l-27.915 16.154z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "m158.855 198.652 28.268-16.153-28.268-16.335z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M223.493 198.824v-32.439l-28.228 16.134zM251.125 175.198a67.74 67.74 0 0 0 7.98-29.181l-29.388 16.819z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "m227.558 159.388 28.369-16.214-28.369-16.295z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M223.493 119.871V87.625l-28.097 16.103zM223.492 159.247v-32.539l-28.157 16.294z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "M158.855 126.647v32.781l28.369-16.416z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M189.05 75a67.8 67.8 0 0 0-29.903 7.895l29.903 17.142z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "M158.855 87.403v32.589l28.389-16.275z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M154.789 85.426a68.5 68.5 0 0 0-21.6 21.73l21.6 12.463z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "M223.311 83.067A67.86 67.86 0 0 0 193.106 75v25.36zM123 145.453a67.8 67.8 0 0 0 8.142 30.008l21.882-12.665zM131.141 110.665A67.7 67.7 0 0 0 123 140.542l30.054-17.233z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M159.097 203.19a67.75 67.75 0 0 0 29.953 7.936v-25.058z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "M249.027 107.267a68.5 68.5 0 0 0-21.469-21.7v34.102zM227.558 200.578a68.6 68.6 0 0 0 21.55-21.86l-21.55-12.443z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M259.196 140.35a67.6 67.6 0 0 0-8.071-29.594l-21.7 12.523z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D3A9",
    d: "M193.106 211.125a67.7 67.7 0 0 0 29.892-7.895l-29.892-17.313z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B39F",
    d: "M154.789 159.136V126.99l-27.925 16.002z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 143,
    r: 78.5,
    stroke: "#00D3A9",
    strokeWidth: 3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C4EE5",
    fillRule: "evenodd",
    d: "M39.965 245.298v-21.87l-18.943-10.939v21.87zm0-24.26-18.943-10.94V188.22l18.943 10.939z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#4040B2",
    fillRule: "evenodd",
    d: "M61 210.089V188.21l-18.951 10.94v21.879z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C4EE5",
    fillRule: "evenodd",
    d: "M18.943 208.818v-21.879L0 176v21.879z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#099CEC",
    d: "M69.818 13.281h-7.521v6.84h7.52zM69.818 21.483h-7.521v6.76h7.52zM60.936 13.281h-7.521v6.84h7.52zM78.713 21.483h-7.52v6.76h7.52zM69.818 5h-7.521v6.903h7.52zM52.037 13.281h-7.52v6.84h7.52zM60.936 21.483h-7.521v6.76h7.52z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#099CEC",
    d: "M101.31 24.65c-1.647-1.109-5.415-1.505-8.313-.95-.38-2.724-1.9-5.115-4.67-7.252l-1.6-1.061-1.06 1.6c-2.09 3.166-2.66 8.375-.428 11.811-.998.538-2.93 1.267-5.51 1.22H30.28c-.997 5.779.665 13.284 5.004 18.445C39.496 53.451 45.829 56 54.11 56c17.908 0 31.176-8.25 37.367-23.244 2.439.048 7.695.016 10.387-5.146.174-.284.744-1.504.966-1.947z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#099CEC",
    d: "M43.17 21.483h-7.522v6.76h7.521zM52.037 21.483h-7.52v6.76h7.52z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#326CE5",
    fillRule: "evenodd",
    d: "M271.798 36.133c-9.463-4.53-13.461-15.875-8.932-25.338a19 19 0 0 1 25.336-8.933c9.463 4.53 13.461 15.875 8.931 25.339-4.529 9.464-15.873 13.463-25.335 8.932",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M279.82 7.349a1.6 1.6 0 0 0-.614.155l-8.388 4.008a1.6 1.6 0 0 0-.868 1.08l-2.069 9.002a1.587 1.587 0 0 0 .309 1.346l5.805 7.218a1.61 1.61 0 0 0 1.254.599l9.311-.002a1.61 1.61 0 0 0 1.254-.598l5.803-7.22a1.568 1.568 0 0 0 .31-1.346l-2.072-9.002a1.6 1.6 0 0 0-.868-1.08l-8.389-4.005a1.6 1.6 0 0 0-.778-.155"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#326CE5",
    stroke: "#326CE5",
    strokeWidth: 0.25,
    d: "M279.904 10.412c-.278 0-.502.25-.502.558l.001.014c-.001.042-.003.092-.001.129.006.178.045.314.068.477.042.35.078.641.056.911a.55.55 0 0 1-.163.26l-.012.212q-.452.036-.907.14a6.46 6.46 0 0 0-3.281 1.874l-.181-.13c-.09.013-.18.04-.298-.028-.225-.151-.43-.36-.677-.612-.114-.12-.196-.235-.331-.35-.03-.027-.077-.062-.111-.09a.6.6 0 0 0-.35-.131.48.48 0 0 0-.4.177c-.173.216-.118.548.123.74l.008.005c.033.027.073.061.104.084.143.105.274.16.416.243.3.186.549.34.747.525.077.082.09.227.101.29l.16.143a6.5 6.5 0 0 0-1.024 4.53l-.21.06c-.056.072-.134.185-.216.218-.258.082-.549.111-.9.148-.165.014-.307.006-.482.039-.038.007-.092.021-.134.031l-.004.001-.007.002c-.296.072-.486.344-.425.612s.35.43.648.367l.007-.002q.006 0 .01-.003c.041-.009.093-.019.13-.029.171-.046.296-.113.45-.172.332-.12.608-.219.876-.258.112-.009.229.07.288.102l.219-.037a6.54 6.54 0 0 0 2.895 3.615l-.091.218c.033.085.069.2.045.284-.098.253-.265.52-.455.817-.092.137-.186.244-.269.401-.02.038-.045.096-.064.136-.129.276-.035.593.213.713.25.12.559-.007.693-.283l.001-.001v-.002c.019-.039.046-.09.062-.127.072-.163.095-.303.145-.46.133-.334.206-.684.389-.902.05-.06.132-.083.216-.106l.114-.206a6.5 6.5 0 0 0 4.633.012l.107.193c.086.028.18.043.257.156.137.234.23.51.344.844.05.158.075.297.146.46.016.037.043.09.062.129.134.277.445.405.694.284.248-.12.343-.437.214-.713-.019-.04-.046-.098-.066-.135-.083-.158-.177-.263-.269-.4-.19-.298-.348-.545-.445-.797-.041-.13.007-.212.039-.296-.019-.022-.06-.145-.084-.203a6.53 6.53 0 0 0 2.894-3.641c.065.01.178.03.215.037.075-.05.145-.114.281-.104.268.04.543.139.875.258.154.059.279.128.451.174.036.01.088.018.129.027l.01.004h.008c.297.065.586-.098.648-.366.061-.268-.129-.54-.425-.611-.043-.01-.104-.027-.146-.035-.175-.033-.317-.025-.482-.038-.351-.037-.642-.067-.9-.148-.105-.041-.18-.167-.217-.218l-.202-.06a6.5 6.5 0 0 0-1.046-4.518l.178-.16c.008-.09.001-.184.094-.284.198-.185.447-.339.747-.524.142-.084.274-.138.417-.244.033-.024.077-.062.111-.089.24-.192.296-.523.123-.74s-.508-.237-.749-.045c-.034.027-.081.062-.111.089-.135.116-.218.23-.332.35-.247.252-.452.462-.677.613-.097.057-.24.037-.304.034l-.191.136a6.58 6.58 0 0 0-4.168-2.014l-.012-.224c-.065-.062-.144-.116-.164-.251-.022-.27.015-.56.057-.91.023-.164.062-.3.069-.478.001-.04-.001-.1-.001-.143 0-.308-.225-.558-.502-.558Zm-.629 3.894-.149 2.634-.011.005a.443.443 0 0 1-.703.34l-.004.001-2.159-1.53a5.17 5.17 0 0 1 3.026-1.45Zm1.258 0a5.2 5.2 0 0 1 3.008 1.45l-2.145 1.522-.008-.003a.443.443 0 0 1-.703-.338l-.003-.001zm-5.067 2.433 1.971 1.764-.002.01a.442.442 0 0 1-.174.761l-.002.009-2.527.73a5.17 5.17 0 0 1 .734-3.274Zm8.862.001c.293.475.514 1.006.646 1.58.131.569.164 1.136.11 1.684l-2.54-.732-.003-.01a.443.443 0 0 1-.173-.761l-.001-.006 1.961-1.755Zm-4.829 1.9h.808l.502.627-.18.783-.725.348-.728-.35-.18-.782zm2.59 2.147a.4.4 0 0 1 .102.007l.004-.005 2.614.442a5.17 5.17 0 0 1-2.093 2.63l-1.014-2.452.003-.004a.444.444 0 0 1 .384-.618Zm-4.391.01a.442.442 0 0 1 .4.617l.008.01-1.004 2.427a5.2 5.2 0 0 1-2.087-2.611l2.592-.44.004.005a.5.5 0 0 1 .087-.008Zm2.19 1.064a.444.444 0 0 1 .405.233h.01l1.277 2.308a5.192 5.192 0 0 1-3.343-.003l1.274-2.305h.002a.45.45 0 0 1 .375-.233Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00D3A9",
    d: "m117.178 182.467-42 16M249.283 210.588l32 22"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 198,
    r: 5,
    fill: "url(#meshery-integrations_svg__paint0_linear_15459_21866)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 231,
    r: 5,
    fill: "url(#meshery-integrations_svg__paint1_linear_15459_21866)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00D3A9",
    d: "M129.657 85.364 97.785 55.375"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.04,
    cy: 57.323,
    r: 5,
    fill: "url(#meshery-integrations_svg__paint2_linear_15459_21866)",
    transform: "rotate(50.418 100.04 57.323)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00D3A9",
    d: "m237.624 72.671 24.729-28.259M276 139.5h46"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.043,
    cy: 45.043,
    r: 5,
    fill: "url(#meshery-integrations_svg__paint3_linear_15459_21866)",
    transform: "rotate(129.899 262.043 45.043)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.047,
    cy: 139.047,
    r: 5,
    fill: "url(#meshery-integrations_svg__paint4_linear_15459_21866)",
    transform: "rotate(139.716 323.047 139.047)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#466BB0",
    d: "M333 156.25h36L346.5 163zM333 154l13.5-2.25V127zM348.5 151.75l20.25 2.25-20.25-45z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshery-integrations_svg__paint0_linear_15459_21866",
    x1: 69.6,
    x2: 81.143,
    y1: 193,
    y2: 200.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#0FECAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshery-integrations_svg__paint1_linear_15459_21866",
    x1: 272.6,
    x2: 284.143,
    y1: 226,
    y2: 233.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#0FECAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshery-integrations_svg__paint2_linear_15459_21866",
    x1: 94.64,
    x2: 106.182,
    y1: 52.323,
    y2: 59.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#0FECAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshery-integrations_svg__paint3_linear_15459_21866",
    x1: 256.643,
    x2: 268.186,
    y1: 40.043,
    y2: 47.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#0FECAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meshery-integrations_svg__paint4_linear_15459_21866",
    x1: 317.647,
    x2: 329.19,
    y1: 134.047,
    y2: 141.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#0FECAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B39F"
  })))));
};
export { SvgMesheryIntegrations as ReactComponent };
export default __webpack_public_path__ + "static/meshery-integrations.e82003a0.svg";